import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { SmallCardButton } from "./../Controls";

const CreditHistory: React.FunctionComponent<{
  onSubmit?: (value: "no" | "both" | "bankruptcy" | "foreclosure") => void;
}> = (props: {
  onSubmit?: (value: "no" | "both" | "bankruptcy" | "foreclosure") => void;
}) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (
    value: "no" | "both" | "bankruptcy" | "foreclosure"
  ) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            Have you had a bankruptcy or foreclosure in the last 7 years?
          </h1>
        }
      >
        <div className="form-cardBtns-wrapper form-inputs-wrapper">
          <SmallCardButton
            label="No"
            icon={
              <i className="icon-nbr-yes">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </i>
            }
            onClick={() => {
              handleSubmit("no");
            }}
            active={loanFormContext.creditHistory?.type === "no" ? true : false}
          />
          <SmallCardButton
            label="Bankruptcy"
            icon={<i className="icon-nbr-bank"></i>}
            onClick={() => {
              handleSubmit("bankruptcy");
            }}
            active={
              loanFormContext.creditHistory?.type === "bankruptcy"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Foreclosure"
            icon={<i className="icon-nbr-foreclosure"></i>}
            onClick={() => {
              handleSubmit("foreclosure");
            }}
            active={
              loanFormContext.creditHistory?.type === "foreclosure"
                ? true
                : false
            }
          />
          <SmallCardButton
            label="Both"
            icon={
              <i className="icon-nbr-no">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </i>
            }
            onClick={() => {
              handleSubmit("both");
            }}
            active={
              loanFormContext.creditHistory?.type === "both" ? true : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export default CreditHistory;
